import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSession } from '../../contexts/SessionContext';

// Create permissions context
const PermissionsContext = createContext();

// PermissionsProvider component
export const PermissionsProvider = ({ children }) => {
  const { user } = useSession();
  const [permissions, setPermissions] = useState({
    slug: null,
    can_view_new_orders: false,
    can_view_order_history: false,
    can_manage_settings: false,
    can_edit_product_data: false,
    can_change_product_status: false,
    can_view_product_statistics: false,
    can_view_revenue_statistics: false,
    can_view_changelog: false, // Nieuwe permissie voor changelog
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPermissions();
  }, [user]);

  const loadPermissions = async () => {
    try {
      // Get permissions from localStorage (custom auth)
      const storedUser = localStorage.getItem('kmfc_user');
      
      console.log('🔍 Loading permissions from localStorage...');
      console.log('📦 Stored user data:', storedUser);
      
      if (storedUser) {
        const userData = JSON.parse(storedUser);
        console.log('👤 Parsed user data:', userData);
        
        if (userData.role) {
          // Use role data from login
          const roleData = userData.role;
          
          // Voeg changelog permissie toe op basis van rol
          if (roleData.slug === 'admin') {
            roleData.can_view_changelog = true;
          } else if (roleData.slug === 'manager') {
            roleData.can_view_changelog = true;
          } else {
            // Medewerker en andere rollen kunnen geen changelog zien
            roleData.can_view_changelog = false;
          }
          
          setPermissions(roleData);
          console.log('✅ Permissions loaded from user data:', roleData);
        } else {
          console.log('❌ No role data found in user data');
          console.log('🔍 Available keys:', Object.keys(userData));
        }
      } else {
        console.log('❌ No user data found in localStorage');
      }
    } catch (error) {
      console.error('Error loading permissions:', error);
    } finally {
      setLoading(false);
    }
  };

  const hasPermission = (permission) => {
    // Check of user admin rol heeft (slug: 'admin')
    if (permission === 'admin') {
      const isAdmin = permissions.slug === 'admin';
      console.log(`🔐 Admin check: ${permissions.slug} = ${isAdmin}`);
      return isAdmin;
    }
    
    const result = permissions[permission] || false;
    console.log(`🔐 Permission check: ${permission} = ${result}`);
    console.log('📋 All permissions:', permissions);
    return result;
  };

  const value = {
    permissions,
    loading,
    refetch: loadPermissions,
    hasPermission
  };

  return (
    <PermissionsContext.Provider value={value}>
      {children}
    </PermissionsContext.Provider>
  );
};

// Hook to use permissions context
export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }
  return context;
};
